interface TemplatePreviewProps {
  template: {
    id: string;
    name: string;
    description: string;
    category: string;
    features: string[];
    techStack: string[];
  };
  onClose: () => void;
  onUse: () => void;
}

export function TemplatePreview({
  template,
  onClose,
  onUse,
}: TemplatePreviewProps) {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-gray-200">
          <h2 className="text-2xl font-bold text-gray-900">{template.name}</h2>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-2xl"
          >
            ✕
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto max-h-[calc(90vh-200px)]">
          <div className="border-b border-gray-200 bg-gray-50 p-6">
            <p className="text-sm text-gray-700">{template.description}</p>
          </div>

          {/* Details */}
          <div className="p-6">
            <p className="mb-4 text-sm font-medium text-gray-500">
              {template.category}
            </p>
            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Features
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-6">
              {template.features.map((feature, index) => (
                <div key={index} className="flex items-start gap-2">
                  <div className="shrink-0 w-5 h-5 rounded-full bg-green-100 flex items-center justify-center text-green-600 text-sm font-medium">
                    ✓
                  </div>
                  <p className="text-sm text-gray-700">{feature}</p>
                </div>
              ))}
            </div>

            <h3 className="text-lg font-semibold text-gray-900 mb-4">
              Tech Stack
            </h3>
            <div className="flex flex-wrap gap-2 mb-6">
              {template.techStack.map((tech, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-gray-100 text-gray-700 text-sm rounded-sm"
                >
                  {tech}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="p-6 border-t border-gray-200 bg-gray-50">
          <div className="flex gap-3">
            <button
              onClick={onClose}
              className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-100 transition-colors"
            >
              Cancel
            </button>
            <button
              onClick={onUse}
              className="flex-1 px-6 py-3 bg-blue-600 text-white text-center rounded-lg font-medium hover:bg-blue-700 transition-colors"
            >
              🚀 Start Build
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TemplatePreview;
